import {ApplicationService} from "@hec/models";
import { DormerMaterialService } from ".";

export const requiredDormerMaterialServices = (): ApplicationService[] => {
  return [
    new DormerMaterialService()
  ];
}
